/* This is the EMIS taching and non teaching staff primary school components */
<template>
  <v-container>
    <div>
      <span v-html="title"></span>
      <HelpIcon :help="htext"/>
    </div>
    <div>
      <table style="height: 72px" border="1px;" width="480" cellspacing="0px;">
        <tbody>
          <tr>
            <td
              style="
                width: 240px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
              rowspan="2"
            >
              មុខងារ
            </td>
            <td class="row-header" colspan="2">ចំនួនបុគ្គលិក</td>
            <td class="row-header" colspan="2">
              <p>បុគ្គលិកបាន</p>
              បណ្ដុះបណ្ដាល
            </td>
          </tr>
          <tr>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
          </tr>
          <tr v-for="(value, row) in b4.length" :key="row">
            <td
              style="
                width: 240px;
                height: 25px;
                text-align: left;
                vertical-align: middle;
              "
            >
              {{ b4[row] }}
            </td>
            <td
              v-for="(value, col) in data[row].dt.length"
              :key="col"
              class="row-data"
            >
              <numberinput v-model="data[row].dt[col]" class="number" />
            </td>
          </tr>
          <!-- Total row -->
          <tr>
            <td
              style="
                width: 240px;
                height: 25px;
                text-align: left;
                vertical-align: middle;
              "
            >
              <strong>សរុប</strong>
            </td>
            <td
              v-for="(value, col) in totalRow.length"
              :key="col"
              class="row-data"
            >
              <strong>{{ totalRow[col] | blank }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
import { b4 } from "@/utils/priascf/commonVariables.js";
export default {
  props: ["data", "title", "htext"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      b4: b4,
    };
  },
  computed: {
    // need to update the total staff in json data
    totalRow: function () {
      let result = [];

      this.data.forEach(function (a) {
          a.dt.forEach(function (b, i) {
              result[i] = (result[i] || 0) + Number(b);
          });
      });

    return result;
    },
    /*
    totalRow: function () {
      let result;
      let d = this.data;
      let ldata = this.data.length - 1;

      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (ind < ldata) {
            // do summing 0 to last - 1 only (last is sum array)
            r[i] = (r[i] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      // update the total row array in JSON
      d[ldata].dt.forEach(function (b, i) {
        d[ldata].dt[i] = result[i];
      });
      return result;
    },*/
  },
  filters: {
    blank: function (value) {
      if (value == 0) return "";
      return value;
    },
  },
};
</script>

<style scoped>
.number {
  width: 60px;
  text-align: center;
}
.row-data {
  width: 60px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.row-header {
  width: 120px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
</style>